import { env } from '@config/env';

import { createConsoleAnalytics, createNoopAnalytics } from './consoleAnalytics';
import { createPostHogAnalytics } from './posthogAnalytics';
import type { Analytics } from './types';

function pickAnalytics(): Analytics {
  if (env.VITE_POSTHOG_KEY) {
    return createPostHogAnalytics({
      apiKey: env.VITE_POSTHOG_KEY,
      ...(env.VITE_POSTHOG_HOST ? { apiHost: env.VITE_POSTHOG_HOST } : {}),
    });
  }
  // Console adapter is useful in dev; production with no key gets a noop
  // so analytics calls are guaranteed cheap and side-effect-free.
  return import.meta.env.DEV ? createConsoleAnalytics() : createNoopAnalytics();
}

let analytics: Analytics = pickAnalytics();

export function getAnalytics(): Analytics {
  return analytics;
}

/** Test / debug override. */
export function __setAnalytics(custom: Analytics): void {
  analytics = custom;
}
